import sha256 from 'crypto-js/sha256'

import { PHONE_COUNTRY_CODE } from '../constants/env'
import type { UserInfo } from '../types/user'
import { trackAdjustEvent } from './adjust'
import { api } from './api-client'
import { trackEvent, trackFb, trackTwitter } from './gtm'
import { trackNativeEvent } from './nativeBridge'

/** Side effects and conversion analytics for a freshly created account. */
export const trackRegistrationSuccess = (user: UserInfo) => {
  api.post('/conduct.php', {
    type: 'activate_game',
  })

  api.post('/conduct.php', {
    type: 'send_register_email',
  })

  trackEvent('registration_success', {
    event_category: 'register',
    event_action: 'action_complete',
    event_label: 'Registration Third Step',
    username: user.username,
  })
  trackNativeEvent('af_registration', { username: user.username })
  trackAdjustEvent('af_registration')

  // FB
  trackFb('track', 'CompleteRegistration', {
    username: user.username,
    value: 1,
    currency: 'MXN',
  })
  // Twitter
  trackTwitter('event', 'tw-olsug-oltxg', {
    email_address: sha256(user.email).toString(),
    phone_number: sha256(`${PHONE_COUNTRY_CODE}${user.phone}`).toString(),
  })
}
